import { memo } from 'react';
import { useDareFormContext } from 'root/src/client/v2/_pages/add-campaign/contexts/dareForm.context';
import { useController } from 'react-hook-form';
import { FormControl } from '@mui/material';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import { DARE_DESCRIPTION_MAX_LENGTH, } from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/dropAddEventPayloadSchema';
import { ErrorField } from 'root/src/client/v2/_pages/add-campaign/components/AddCampaignForm/ErrorField';
import { RequiredMark } from 'root/src/client/v2/_pages/add-campaign/components/AddCampaignForm/RequiredMark';
export const DescriptionField = memo(() => {
    var _a;
    const form = useDareFormContext();
    const { field, fieldState } = useController({
        name: 'description',
        control: form.control,
    });
    return (<FormControl data-error={Boolean(fieldState.error)} error={Boolean(fieldState.error)}>
			<label className="capitalize font-bold" htmlFor="description">
				<RequiredMark />
				Description
			</label>
			<TextField {...field} className="h-40 overflow-auto" id="description" variant="filled" size="small" multiline placeholder="Briefly describe a dare" fullWidth error={Boolean(fieldState.error)}/>
			<ErrorField error={(_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message}/>
			<FormHelperText>Characters remaining: {DARE_DESCRIPTION_MAX_LENGTH - field.value.length}</FormHelperText>
		</FormControl>);
});
